import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import AnimatedSection from "../AnimatedSection/AnimatedSection";
import { t, currentLanguage } from "../../i18n";
import axios from "axios";

const FaqSection: React.FC = () => {
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);
  const [faqQuestions, setFaqQuestions] = useState<any[]>([]);

  const toggleAccordion = (index: number) => {
    if (openIndexes.includes(index)) {
      setOpenIndexes(openIndexes.filter((i) => i !== index));
    } else {
      setOpenIndexes([...openIndexes, index]);
    }
  };

  useEffect(() => {
    const faq = axios.get(`${process.env.REACT_APP_FAQ_ENDPOINT}?language=${currentLanguage}-${currentLanguage.toUpperCase()}`, {
      headers: {
        "Content-Type": "application/json",
        TenantCode: "SENSE",
        UserCode: process.env.REACT_APP_USER_CODE || "",
        languageCode: currentLanguage + "-" + currentLanguage.toUpperCase(),
      },
    });
    faq.then((res) => {
      setFaqQuestions(res.data);
    });
  }, []);
  return (
    <section className="py-16 px-4 sm:px-6 md:px-10 lg:px-20" id="faq">
      <div className="max-w-7xl mx-auto bg-gray-800 px-6 sm:px-10 md:px-16 lg:px-20 py-16 md:py-24 rounded-xl">
        <AnimatedSection>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-10 text-center">{t("faqSection.title")}</h2>
        </AnimatedSection>

        <div className="space-y-4">
          {faqQuestions.map((faq, index) => {
            const isOpen = openIndexes.includes(index);
            return (
              <AnimatedSection key={index} delay={index * 100}>
                <div className="rounded-xl overflow-hidden bg-silver">
                  <button
                    onClick={() => toggleAccordion(index)}
                    className="w-full flex items-center justify-between px-4 sm:px-6 py-5 sm:py-6 text-left focus:outline-none text-base sm:text-lg md:text-xl font-semibold text-gray-800 transition-all duration-300 group hover:bg-gray-50"
                  >
                    {faq.question}
                    <span className="ml-4 flex-shrink-0">
                      {isOpen ? (
                        <ChevronUp size={24} className="text-gray-500 group-hover:text-gray-600 transition-all duration-300 transform rotate-180" />
                      ) : (
                        <ChevronDown size={24} className="text-gray-500 group-hover:text-gray-600 transition-all duration-300" />
                      )}
                    </span>
                  </button>

                  <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}>
                    <div className="px-4 sm:px-6 pb-5 sm:pb-6 text-sm sm:text-base text-gray-700 leading-relaxed overflow-y-auto max-h-64 sm:max-h-80 md:max-h-96">
                      {index === 1 ? (
                        <div>
                          {/* İkinci FAQ sorusu için manuel cevap */}
                          <p>{t("faqSection.answer2")}</p>
                        </div>
                      ) : (
                        faq.answer
                      )}
                    </div>
                  </div>
                </div>
              </AnimatedSection>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
